import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { TextInput, Button2 } from '../../../common'
import Icon from '../../../common/icon'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import BackIcon from '@fortawesome/fontawesome-free-solid/faLongArrowAltLeft'

import * as Strings from './strings'
import * as Styles from './styles'
import * as userActions from '../../../../actions/User'
import * as configActions from '../../../../actions/Config'
import * as Constants from '../../../../helpers/Constants'

class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      emailInput: '',
      passwordInput: ''
    }

    this.enterHandler = this.enterHandler.bind(this)
  }

  componentDidMount() {
    window.addEventListener('keypress', this.enterHandler)

    this.props.tryValidateSession('SE')
  }

  componentWillUnmount() {
    window.removeEventListener('keypress', this.enterHandler)
  }

  enterHandler(e) {
    const { alert } = this.props

    if (e.charCode === 13 && !alert.show) {
      this.signIn()
    } else if (e.charCode === 13) {
      this.props.hideAlert()
    }
  }

  signIn() {
    const { language } = this.props
    const { emailInput, passwordInput } = this.state
    const data = { email: emailInput, password: passwordInput }

    this.props.trySignIn(data, language, (h, i, t, b) =>
      this.props.showAlert(h, i, t, b)
    )
  }

  render() {
    const { emailInput, passwordInput } = this.state
    const { language, history, user, data } = this.props

    if (user.fetched) {
      if (data.privileges.laundryBookingSystem) {
        history.push('/laundrybookings')
      } else if (data.privileges.bookingSystem) {
        history.push('/bookingsystems')
      } else if (data.privileges.errorReportSystem) {
        history.push('/newerrorreport')
      } else if (data.privileges.feedSystem) {
        history.push('/news')
      } else if (data.privileges.infoSystem) {
        history.push('/communityinformation')
      } else {
        history.push('/mypage')
      }
    }

    return (
      <div className={'basicCentered'}>
        <div className={'basicContainer'}>
          {Constants.WHITE_LABEL.others.login.isExamplePage ? (
            <h2 style={{ marginBottom: 80 }}>
              Det här är endast en exempelsida åt {Constants.WHITE_LABEL.name}{' '}
              skapad av HomePal. Hör av er till info@homepal.se för nertagning
              av sidan.
            </h2>
          ) : null}
          <h5>{Strings.default.SIGN_IN[language]}</h5>
          <Input
            header={Strings.default.EMAIL_ADDRESS[language]}
            value={emailInput}
            onChange={value => this.setState({ emailInput: value })}
          />
          <Input
            header={Strings.default.PASSWORD[language]}
            type={'password'}
            value={passwordInput}
            onChange={value => this.setState({ passwordInput: value })}
          />
          <Button2
            onClick={() => this.signIn()}
            header={Strings.default.SIGN_IN[language]}
            loading={user.isFetching || user.isSigningIn}
          />
          {Constants.WHITE_LABEL.others.login.showOptions ? (
            <div style={Styles.default.textContainerStyle}>
              <h4
                onClick={() => history.push('/signup')}
                className={'hoverGreen'}
                style={{
                  textTransform: 'none',
                  textDecoration: 'underline'
                }}
              >
                {Strings.default.CREATE_ACCOUNT[language]}
              </h4>
              <h4
                onClick={() => history.push('/forgotpassword')}
                style={{
                  marginTop: 15,
                  textTransform: 'none',
                  textDecoration: 'underline'
                }}
                className={'hoverGreen'}
              >
                {Strings.default.FORGOT_PASSWORD[language]}
              </h4>
            </div>
          ) : null}
        </div>
      </div>
    )
  }
}

const Input = ({ header = '', value, onChange, type, onIconPressed }) => {
  return (
    <TextInput
      width={'100%'}
      header={header}
      type={type}
      value={value}
      onChange={value => onChange(value)}
      underlineFocusStyle={{ borderColor: Constants.WHITE_LABEL.colors.input }}
      floatingLabelFocusStyle={{ color: Constants.WHITE_LABEL.colors.input }}
      onIconPressed={() => onIconPressed()}
      underlineFocusStyle={{
        borderColor: Constants.WHITE_LABEL.colors.primary
      }}
      floatingLabelFocusStyle={{ color: Constants.WHITE_LABEL.colors.primary }}
    />
  )
}

function mapStateToProps({ user, config, data }) {
  const { language, alert } = config

  return { user, language, alert, data }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...userActions, ...configActions }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)



// WEBPACK FOOTER //
// ./src/components/pages/preLogin/Login/index.js